"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageEffect = exports.PageState = exports.FunctionGetAllStateValue = exports.FunctionGetStateValue = void 0;
const React = __importStar(require("react"));
const Field_Constant_1 = require("../controller/utils/Field.Constant");
const FunctionGetStateValue = (name = "") => {
    const findData = document.querySelector(`#${Field_Constant_1.TEXT_AUTHOR}-state-${name}`);
    if (findData === null || findData === void 0 ? void 0 : findData.className) {
        const thisClassName = findData.className;
        const ThisValue = thisClassName.substring(thisClassName.indexOf("(") + 1, thisClassName.indexOf(")"));
        return JSON.parse(ThisValue);
    }
    else {
        return "Not Found";
    }
};
exports.FunctionGetStateValue = FunctionGetStateValue;
const FunctionGetAllStateValue = () => {
    const findAllData = document.querySelectorAll(`.${Field_Constant_1.TEXT_AUTHOR}-state`);
    let thisData = {};
    findAllData.forEach((data) => {
        const thisClassName = data.className;
        const ThisValue = thisClassName.substring(thisClassName.indexOf("(") + 1, thisClassName.indexOf(")"));
        const thisName = thisClassName.substring(thisClassName.indexOf("[") + 1, thisClassName.indexOf("]"));
        thisData = Object.assign(Object.assign({}, thisData), { [thisName]: JSON.parse(ThisValue) });
    });
    return thisData;
};
exports.FunctionGetAllStateValue = FunctionGetAllStateValue;
const PageState = ({ body, initalState = "", name = "", }) => {
    const [state, setState] = React.useState(initalState);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: `${Field_Constant_1.TEXT_AUTHOR}-state-${name}`, className: `${Field_Constant_1.TEXT_AUTHOR}-state ${name} [${name}] : (${JSON.stringify(state)})`, defaultValue: state, style: {
                display: "none",
            } }),
        body({ state, setState })));
};
exports.PageState = PageState;
const PageEffect = (action = () => { }, dependencies = []) => {
    React.useEffect(() => {
        action();
    }, dependencies);
};
exports.PageEffect = PageEffect;
